export default __webpack_public_path__ + "media/img/primary-bottom-73fc22acbc1770e6569d5461c866558b.svg";